// The small red light that follows the pointer across tiles (.rc-tile, or any element with .rc-lit).
// One passive listener for the whole app; it only writes two CSS variables on the element under the
// mouse, once per frame. Touch and pen input are ignored: on phones a tile lights from the top on press.
export function installPointerLight(root = typeof document === 'undefined' ? null : document) {
  if (!root || typeof window === 'undefined') return () => {};
  let frame = 0;
  let last = null;

  const paint = () => {
    frame = 0;
    const target = last && last.target instanceof Element ? last.target.closest('.rc-tile, .rc-lit') : null;
    if (!target) return;
    const rect = target.getBoundingClientRect();
    target.style.setProperty('--rc-mx', `${Math.round(last.clientX - rect.left)}px`);
    target.style.setProperty('--rc-my', `${Math.round(last.clientY - rect.top)}px`);
  };

  const onMove = (event) => {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    last = event;
    if (!frame) frame = window.requestAnimationFrame(paint);
  };

  root.addEventListener('pointermove', onMove, { passive: true });
  return () => {
    root.removeEventListener('pointermove', onMove);
    if (frame) window.cancelAnimationFrame(frame);
  };
}
